export const log = (...args) => {
  if (process.env.NODE_ENV === "development") {
    console.log(...args);
  }
};

export const errorLog = (...args) => {
  if (process.env.NODE_ENV === "development") {
    console.error(...args);
  }
};